import { LiveFormDTO } from '../dto/liveform-dto';
import { LiveForm } from '../models/liveform';
import { OrderFactory } from './order.factory';
import { LFProjectFactory } from './lfproject.factory';
import { LFOfflineOrderDto, LFOfflineOrderSourceType } from '../models/lf-offline-order';

export class LiveFormFactory {
  static fromLiveFormDTO(dto: LiveFormDTO): LiveForm {
    const item = new LiveForm();
    item.id = dto.id;
    item.formData = dto.formData;
    item.nameAndRevision = dto.nameAndRevision;
    item.subStates = dto.substates.map((dto) => OrderFactory.fromSubStateDTO(dto));
    item.idsOfHiddenItems = dto.idsOfHiddenItems ?? [];

    if (dto.project) {
      item.project = LFProjectFactory.fromDTO(dto.project);
    }
    if (dto.order) {
      item.order = OrderFactory.fromOrderDTO(dto.order);
    }
    if (dto.attachedResources) {
      item.attachedResources = dto.attachedResources.map((res) => OrderFactory.fromResourceInfoDTO(res));
    }
    return item;
  }

  static toLiveFormOfflineDto(
    form: LiveForm,
    sourceType: LFOfflineOrderSourceType,
    isTemporaryOffline: boolean = false
  ): LFOfflineOrderDto {
    return {
      id: form.id,
      form: {
        formData: form.formData,
        id: form.id,
        nameAndRevision: form.nameAndRevision,
        order: OrderFactory.toOrderDTO(form.order),
        project: form.project,
        substates: form.subStates,
        attachedResources: form.attachedResources,
        idsOfHiddenItems: form.idsOfHiddenItems
      },
      sourceType,
      updatedAt: new Date(),
      isTemporaryOffline: isTemporaryOffline
    };
  }
}
